import api from "./../utils/api";

export const getUserLogin = async (userId) => {
  try {
    const response = await api.get(
      `/interaction/user-login/${userId}`,
      {
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};